import ActivityLog from './components/ActivityLog/ActivityLog';
import Filters from './components/Filters/Filters';
import MarksTable from './components/MarksTable/MarksTable';
import styles from './Marks.module.scss';

const Marks: React.FC = () => {
  return (
    <div className={styles.marksPage}>
      <div className={styles.filters}>
        <Filters />
      </div>
      <div className={styles.content}>
        <div className={styles.marks}>
          <MarksTable />
        </div>
        <div className={styles.activity}>
          <ActivityLog />
        </div>
      </div>
    </div>
  );
};

export default Marks;
